/*
 * Copyright (c) 2020, Neustar, Inc.
 * UNPUBLISHED PROPRIETARY SOURCE CODE
 *
 */

import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import actions from "../actionTypes";
import _ from 'lodash';
import { clearCookies } from "../common/helpers/getCookie";

class ErrorModal extends Component {
  state = {
    showModal: true
  }
  handleClose = () => {
    if (_.toLower(this.props.type) === 'unauthorized') {
      clearCookies();
      window.location = `${window.location.origin}/manage/#/saml/sso/logout?email=${_.get(this.props, 'userInfo.email', '')}`;
      window.localStorage.clear();
    }
    this.setState({ showModal: false });
    this.props.updateErrorModal(false);
  }
  render() {
    return (
      <React.Fragment>
        <Modal
          show={this.state.showModal}
          backdrop="static"
          keyboard={false}
          onHide={this.handleClose}
          size="sm"
        >
          <Modal.Body className="text-center">
            {
              !_.isEmpty(this.props.errMessage) ?
                <p>{this.props.errMessage}</p> :
                _.toLower(this.props.type) === 'unauthorized' ?
                    <p>
                      You're not authorized to access this.
                    </p> :
                    <p>
                      We're sorry but something went wrong on the backend – please try again.
                    </p>
            }
            <Button variant="secondary" onClick={this.handleClose}>Close</Button>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

export default connect(
  state => ({
  }),
  dispatch => ({
    updateErrorModal: (bool) => {
      dispatch({
        type: actions.SET_IN_REDUX,
        payload: {
          path: 'endpoints.hasError'.split('.'),
          data: {
            show: bool,
            type: ''
          }
        }
      })
    }
  })
)(ErrorModal);
